import React, { useState, useCallback, useRef, createContext, useContext } from 'react';

// Confirm Context
const ConfirmContext = createContext();

// Confirm Provider
export function ConfirmProvider({ children }) {
    const [confirmState, setConfirmState] = useState({
        open: false,
        message: '',
        onYes: null,
        onNo: null,
    });

    const Confirm = useCallback(({ msg, onYes, onNo }) => {
        setConfirmState({
            open: true,
            message: msg,
            onYes,
            onNo,
        });
    }, []);

    const handleYes = () => {
        setConfirmState((prev) => ({ ...prev, open: false }));
        confirmState.onYes && confirmState.onYes();
    };

    const handleNo = () => {
        setConfirmState((prev) => ({ ...prev, open: false }));
        confirmState.onNo && confirmState.onNo();
    };

    return (
        <ConfirmContext.Provider value={Confirm}>
            {children}
            {confirmState.open && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999]">                    
                    <div className="bg-white p-6 rounded-lg min-w-[300px]">
                        <div className="mb-4">{confirmState.message}</div>
                        <div className="flex justify-end gap-2">
                            <button
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
                                onClick={handleYes}
                            >
                                Yes
                            </button>
                            <button
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition"
                                onClick={handleNo}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </ConfirmContext.Provider>
    );
}

// useConfirm Hook
export function useConfirm() {
    return useContext(ConfirmContext);
}

// Example usage in App.jsx
/*

function App() {
    return (
        <ConfirmProvider>
            <MyComponent />
        </ConfirmProvider>
    );
}

function MyComponent() {
    const Confirm = useConfirm();

    const handleClick = () => {
        Confirm({
            msg: 'Are you sure?',
            onYes: () => alert('You clicked Yes!'),
            onNo: () => alert('You clicked No!'),
        });
    };

    return <button onClick={handleClick}>Show Confirm</button>;
}
*/